import React from 'react';

const FeaturedEventList = (props) => {
  const { events, activeId } = props;

  const eventList = events.map((event, i) => {

    return (
      <div
        key={event.id}
        className={ event.id === activeId ? 'event-active featured-event-preview' : 'featured-event-preview'}
        onClick={(e) => props.onEventClick(event.id)}
      >
        <img src={`/images/events/${event.filename}`} />
        <h5>{event.title}</h5>
      </div>
    );
  })


  return (
    <div className="featured-event-list">
      {eventList}
    </div>
  );
}

export default FeaturedEventList;
